
import store from '@/store';
import Http from '@/services/http';
import AuthenticationService from '@/services/authentication';
import { accessPending } from '@/domain/enums/login';
import router, { HOME_ROUTE } from '@/router';

const urls = {
  base: '/Licenciamento',
};

function acceptLicense(userData) {
  const http = new Http();
  return http.post(urls.base, {
    nomeCompletoUsuario: (userData.name || '').toUpperCase(),
    cpf: userData.cpf,
  }).then(response => response.data);
}

export default {
  getLicense() {
    const http = new Http();
    return http.get(urls.base).then(response => response.data);
  },

  /**
   * @param {Object} userData
   * @param {String} userData.usuario
   * @param {String} userData.cpf
   * @returns {Promise}
   */
  acceptLicenseAndProceed(userData) {
    acceptLicense(userData)
      .then(() => AuthenticationService.newToken())
      .then(() => {
        store.dispatch('removeAccessPending', accessPending.LICENSE);
        router.push(HOME_ROUTE);
      });
  },
};
